var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHealth = function SvgHealth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.67 12.505 12.008 19l-6.663-6.495a4.368 4.368 0 0 1-1.017-1.486 4.31 4.31 0 0 1 .094-3.505 4.379 4.379 0 0 1 1.095-1.432 4.462 4.462 0 0 1 1.586-.878 4.51 4.51 0 0 1 3.543.372c.533.299.997.704 1.362 1.188.368-.48.832-.882 1.364-1.178a4.493 4.493 0 0 1 3.534-.36c.583.182 1.12.48 1.58.877.46.397.832.882 1.092 1.427a4.316 4.316 0 0 1-.906 4.98",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 13h5.5l2-4 2 4H21",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgHealth;